import type { SelectSingleEventHandler } from 'react-day-picker';
import { Calendar } from '../calendar';

interface CombocalProps {
  onSelectDate: SelectSingleEventHandler;
  date: Date | undefined;
}

export const Combocal = ({ onSelectDate, date }: CombocalProps) => {
  return (
    <div className="w-fit p-0 z-1000">
      <Calendar
        // UX NOTE: We want the view to be re-rendered when the date changes
        // so that the calendar is updated with the new date
        // Thus we need to use a key to force a re-render
        key={`combocal-${date?.toISOString()}`}
        mode="single"
        selected={date}
        onSelect={(...rest) => {
          onSelectDate(...rest);
        }}
        className="rounded-md border shadow-sm"
        defaultMonth={date}
      />
    </div>
  );
};
